import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { connect as connectR } from 'react-redux';
import {
    Button,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
} from 'react-bootstrap';
import LargeCard from '../main/large-card';
import translate from '../translate';
import { LoginAsPartner } from '../../store/authSlice';
import { goToEndOfLogin, goToPasswordReset } from '../../nav/navigationService';

const LoginEntry = createReactClass({
    displayName: 'LoginEntry',

    propTypes: {
        strings: PropTypes.shape({
            mainTitle: PropTypes.string,
            email: PropTypes.string,
            password: PropTypes.string,
            passwordReset: PropTypes.string,
            login: PropTypes.string,
            error: PropTypes.shape({}),
        }).isRequired,
        authError: PropTypes.string,
        LoginAsPartner: PropTypes.func.isRequired,
    },

    contextTypes: {
        router: PropTypes.object.isRequired,
        strings: PropTypes.object,
    },

    getDefaultProps() {
        return {
            authError: undefined,
        };
    },

    getInitialState() {
        return {
            email: '',
            password: '',
        };
    },

    _handleSubmit(event) {
        event.preventDefault();
        this.props.LoginAsPartner(
            this.state.email,
            this.state.password,
            goToEndOfLogin
        );
    },

    _onEmailChange(e) {
        this.setState({ email: e.target.value });
    },

    _onPasswordChange(e) {
        this.setState({ password: e.target.value });
    },

    render() {
        let errorMessage = null;
        if (this.props.authError) {
            errorMessage = (
                <div className="alert alert-danger pull-right">
                    <i className="fa fa-exclamation-circle fa-fw" />{' '}
                    {this.props.strings.error[this.props.authError]}
                </div>
            );
        }

        const formContent = (
            <LargeCard type="card-edit" title={this.props.strings.mainTitle}>
                <FormGroup controlId="formValidationSuccess4">
                    <ControlLabel>{this.props.strings.email}</ControlLabel>
                    <FormControl
                        data-testid="email-field"
                        ref="email"
                        type="email"
                        className="input-text-color"
                        value={this.state.email}
                        name="email"
                        onChange={this._onEmailChange}
                        required
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel>{this.props.strings.password}</ControlLabel>
                    <FormControl
                        data-testid="password-field"
                        ref="password"
                        type="password"
                        className="input-text-color"
                        value={this.state.password}
                        name="password"
                        onChange={this._onPasswordChange}
                        required
                    />
                </FormGroup>

                <div className="clearfix"></div>
                <div className="form-footer">
                    <Button
                        className="btn-primary"
                        type="submit"
                        data-testid="login-button"
                    >
                        {this.props.strings.login}
                    </Button>
                    <Button
                        onClick={goToPasswordReset}
                        className="btn-link pull-right"
                        data-testid="password-reset-button"
                    >
                        {this.props.strings.passwordReset}
                    </Button>
                    {errorMessage}
                </div>
            </LargeCard>
        );

        return <Form onSubmit={this._handleSubmit}>{formContent}</Form>;
    },
});

export default connectR(
    (rootStore) => ({
        authError: rootStore.auth.authentication.error,
    }),
    { LoginAsPartner }
)(translate('LoginEntry')(LoginEntry));
